// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { PopupMenuModule } from 'libraries/component/popup-menu/popup-menu.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { CardModule } from 'libraries/ui_card/card.module';
import {ProcessingResultContainerComponent} from "./processing-result-container.component";
import {ProcessingListModule} from "../processing-list/processing-list.module";

@NgModule({
    imports: [
        CommonModule,
        NotificationModule,
        PopupMenuModule,
        LoaderModule,
        CardModule,
        ProcessingListModule,
    ],
    exports: [
        ProcessingResultContainerComponent,
    ],
    declarations: [
        ProcessingResultContainerComponent,
    ],
    providers: [
    ],
})
export class ProcessingResultContainerModule { }
